// Utility function to translate status from database value to display value
export const createStatusTranslator = (t) => {
  return (status) => {
    switch (status) {
      case 'Active':
        return t('common:active');
      case 'Inactive':
        return t('common:inactive');
      default:
        return status;
    }
  };
};

// Also create utility for party types, roles, and other translatable enums
export const createPartyTypeTranslator = (t) => {
  return (type) => {
    switch (type) {
      case 'Client':
        return t('pages:files.party_types.client');
      case 'Opposite Party':
        return t('pages:files.party_types.opposite_party');
      case 'Paying Party':
        return t('pages:files.party_types.paying_party');
      case 'Advocate Opposite Party':
        return t('pages:files.party_types.advocate_opposite_party');
      default:
        return type;
    }
  };
};

export const createRoleTranslator = (t) => {
  return (role) => {
    switch (role) {
      case 'Responsible Lawyer':
        return t('pages:files.roles.responsible_lawyer');
      case 'Treating Lawyer':
        return t('pages:files.roles.treating_lawyer');
      default:
        return role;
    }
  };
};

export const createTypeTranslator = (t) => {
  return (type) => {
    switch (type) {
      case 'Liability Law':
        return t('pages:files.types.liability_law');
      case 'Civil Law':
        return t('pages:files.types.civil_law');
      case 'Labor Law':
        return t('pages:files.types.labor_law');
      case 'Administrative Law':
        return t('pages:files.types.administrative_law');
      case 'Tax Law':
        return t('pages:files.types.tax_law');
      case 'Construction Law':
        return t('pages:files.types.construction_law');
      case 'Rental & Residential Law':
        return t('pages:files.types.rental_residential_law');
      case 'Environment & Spatial Planning Law':
        return t('pages:files.types.environment_spatial_law');
      case 'Corporate Law':
        return t('pages:files.types.corporate_law');
      case 'Military Law':
        return t('pages:files.types.military_law');
      case 'Education Law':
        return t('pages:files.types.education_law');
      case 'Other':
        return t('pages:files.types.other');
      case 'Personal & Family Law':
        return t('pages:files.types.personal_family_law');
      case 'Legal Entity Law':
        return t('pages:files.types.legal_entity_law');
      case 'Social Security Law':
        return t('pages:files.types.social_security_law');
      case 'Criminal Law':
        return t('pages:files.types.criminal_law');
      case 'Disciplinary Law':
        return t('pages:files.types.disciplinary_law');
      case 'Law of Obligations':
        return t('pages:files.types.law_obligations');
      case 'Insurance Law':
        return t('pages:files.types.insurance_law');
      case 'Immigration Law':
        return t('pages:files.types.immigration_law');
      case 'Commercial Law':
        return t('pages:files.types.commercial_law');
      default:
        return type;
    }
  };
}; 